import styles from './vehicle_specs_grid.module.scss';

import {VehicleType} from '../../gql/customer/graphql.ts';
import {__} from '../../support/lang/translations.ts';
import {formatKm} from '../../support/format_distance.ts';

interface OwnProps {
    vehicle: VehicleType;
}

export function VehicleSpecsGrid({vehicle}: OwnProps) {
    return (
        <div className={styles.vehicle_specs_grid}>
            <div className={styles.grid_item}>
                <i className="fa-light fa-car"></i>
                <span className={styles.grid_item__title}>{__('vehicles.specs_grid.brand')}</span>
                <span className={styles.grid_item__value}>{vehicle.brand}</span>
            </div>

            <div className={styles.grid_item}>
                <i className="fa-light fa-calendar-check"></i>
                <span className={styles.grid_item__title}>{__('vehicles.specs_grid.inspection_expiration_date')}</span>
                <span className={styles.grid_item__value}>{vehicle.inspection_expiration_date}</span>
            </div>

            <div className={styles.grid_item}>
                <i className="fa-light fa-gauge"></i>
                <span className={styles.grid_item__title}>{__('vehicles.specs_grid.mileage')}</span>
                <span className={styles.grid_item__value}>{formatKm(vehicle.mileage ?? 0)}</span>
            </div>

            <div className={styles.grid_item}>
                <i className="fa-light fa-calendar"></i>
                <span className={styles.grid_item__title}>{__('vehicles.specs_grid.buildyear')}</span>
                <span className={styles.grid_item__value}>{vehicle.buildyear}</span>
            </div>
        </div>
    );
}
